import React from 'react';
import { useFormContext } from 'react-hook-form';
import { TextInputControl } from '@ver-uds/uswds-react';
import { HelpModalProps } from './HelpModal';
import LabelHint from './Enrollment/CompanyInformation/LabelHint';

type FormValues = {
  dunsNumber: string;
};

export type DUNSFieldProps = {
  openModal(content: HelpModalProps['modalContent']): void;
};

const DUNSField = ({ openModal }: DUNSFieldProps): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/unbound-method
  const { register, errors } = useFormContext<FormValues>();

  return (
    <TextInputControl
      id="duns-number"
      name="dunsNumber"
      className="grid-col-6 tablet:grid-col-3 desktop:grid-col-2"
      label="DUNS Number"
      hint="9 digits, numbers only"
      labelHint={<LabelHint openModal={openModal} label="DUNS Number" />}
      ref={register({
        validate: (value: string) => {
          if (!/^\d{9}$/.test(value)) {
            if (value) {
              return 'DUNS Number must be 9 digits in length. Example: 012345678';
            }
          }
          return true;
        },
      })}
      errorId={errors.dunsNumber && 'duns-number-error'}
      errorMessage={errors.dunsNumber?.message}
    />
  );
};

export default DUNSField;
